import cx from 'classnames'

export const CardBody = ({ children, className, ...props }) => <div className={cx('tw:p-5', className)} {...props}>{children}</div>
